var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.833,
    height: 14,
    viewBox: "0 0 12.833 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "format",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Path_37065",
    "data-name": "Path 37065",
    d: "M2.763,3.933A2.783,2.783,0,0,1,5.554,1.165H10.92A1.611,1.611,0,0,0,9.373,0H2.616A1.611,1.611,0,0,0,1,1.6v9.032a1.611,1.611,0,0,0,1.616,1.6h.147Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Path_37066",
    "data-name": "Path 37066",
    d: "M14.373,4H7.616A1.617,1.617,0,0,0,6,5.616v8.52a1.617,1.617,0,0,0,1.616,1.616h6.757a1.617,1.617,0,0,0,1.616-1.616V5.616A1.617,1.617,0,0,0,14.373,4ZM13.2,13.989H8.791a.441.441,0,0,1,0-.881H13.2a.441.441,0,0,1,0,.881Zm0-2.35H8.791a.441.441,0,0,1,0-.881H13.2a.441.441,0,0,1,0,.881Zm0-2.056H8.791a.441.441,0,0,1,0-.881H13.2a.441.441,0,0,1,0,.881Zm0-2.35H8.791a.441.441,0,0,1,0-.881H13.2a.441.441,0,0,1,0,.881Z",
    transform: "translate(-2.155 -1.751)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormat);
export default __webpack_public_path__ + "static/media/format.b4d7b7cf0d0262bce19e2cd1ee92632b.svg";
export { ForwardRef as ReactComponent };